import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useSubheader } from "../../../_metronic/layout";
import { HomeButton } from "../../components/Buttons/HomeButton";
import { ModulePages } from "./ModulePages";
import { apiGETUser } from './ModulePages'
import "./Styles.css"
import { getUserFactoryId } from "../../../index"
import api from '../../services/api';
import env from '../../../env'

export const HomePage = () => {
    const suhbeader = useSubheader();
    suhbeader.setTitle("Home");

    const [email, setEmail] = useState([])
    const [modules, setModules] = useState([])
    useEffect(() => {
        async function get() {
            let newModules = [...ModulePages];

            const access = await api.get(`/rollout/odata?$select=module&$filter=factoryId+eq+${getUserFactoryId()}`)
            console.log(access)
            const lpp = access.data.value.find(a => a.module == 'LPP')
            const dtp = access.data.value.find(a => a.module == 'DTP')
            const idcard = access.data.value.find(a => a.module == 'Idcard')
            const funil = access.data.value.find(a => a.module == 'Funil')
            const mundocta = access.data.value.find(a => a.module == 'Mundo CTA')

            newModules.push(
                { name: 'Ache Aqui!', expandable: false, icon: '/media/svg/icons/General/Search.svg', to: '/Buscador' }
            );

            newModules.push(
                { name: 'Minhas Atividades', expandable: true, icon: '/media/svg/icons/Text/Bullet-list.svg' },
                { name: 'Relatório Geral', expandable: false, icon: '/media/svg/icons/General/Clipboard.svg', to: '/factoryBIassessment' }
            );

            newModules.push(
                { name: 'Matrizes, Rotas e Quadro GTA', expandable: false, icon: '/media/svg/icons/layout/Layout-grid.svg', to: env.BASE_URL_MATRIZ }
            );

            if (lpp ||
                getUserFactoryId() == 1207 ||
                getUserFactoryId() == 1111
                )
                newModules.push(
                    { name: 'LPP', expandable: true, icon: '/media/svg/icons/Layout/Layout-top-panel-5.svg' },
                );

            if (dtp ||
                getUserFactoryId() == 1207 ||
                getUserFactoryId() == 1111
                )
                newModules.push(
                    { name: 'DTP', expandable: true, icon: '/media/svg/icons/Layout/Layout-arrange.svg' },
                );

            if (idcard ||
                getUserFactoryId() == 1207 ||
                getUserFactoryId() == 1111)
                newModules.push(
                    { name: 'ID Card', expandable: true, icon: '/media/svg/icons/Shopping/Ticket.svg' },
                );
                
            if (funil ||
                getUserFactoryId() == 1207 ||
                getUserFactoryId() == 1111)
                newModules.push(
                    { name: 'Funil', expandable: true, icon: '/media/svg/icons/Home/Funil.svg' },
                );

            newModules.push(
                { name: 'App de Etiquetas', expandable: false, icon: '/media/Etiqueta.svg', to: env.BASE_URL_MapaEtiquetas }
            );

            newModules.push(
                    { name: 'Mapas', expandable: false, icon: '/media/svg/icons/Map/Marker1.svg', to: env.BASE_URL_MapaEtiquetas },
            );
                        

            newModules.push(
                { name: 'Biblioteca de Treinamento', expandable: true, icon: '/media/svg/icons/Home/Book-open.svg' }
            );

            
            newModules.push(
                { name: 'Biblioteca de Documentos', expandable: true, icon: '/media/svg/icons/Home/Book-open.svg' }
            );

            if (mundocta || (getUserFactoryId() == 1111 ||
                getUserFactoryId() == 1207 ||
                getUserFactoryId() == 1228)
            ) {
                newModules.push(
                    { name: 'Mundo CTA', expandable: false, icon: '/media/svg/icons/Media/Airplay-video.svg', to: ('https://nbra-pr-mundoctaprod-usea-001-app.azurewebsites.net') },
                )
            }
            
            newModules.push(
                { name: 'Ajuda', expandable: false, icon: '/media/svg/icons/Communication/Group-chat.svg', to: '/HelpIndex' }
            )
            setModules(newModules);

            const administrators = await apiGETUser()
            setEmail(administrators)
        }
        get()
    }, []);

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="card card-custom card-stretch gutter-b">
                        {/* Body */}
                        <div className="card-body p-0 position-relative overflow-hidden">
                            <div className="card-spacer">
                                <div className="row m-0 Justificado">
                                    {modules.map((page, index) => (
                                        page.name === 'Ache Aqui!' || page.name === 'Ajuda' ?
                                            <HomeButton style={{ backgroundColor: "#8cebe7" }} key={index} to={page.to} name={page.name} icon={page.icon} expandable={page.expandable} />
                                            :
                                            <HomeButton style={{ backgroundColor: "#eee5ff" }} key={index} to={page.to} name={page.name} icon={page.icon} expandable={page.expandable} />
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="Admin">
                            <div className="col-12">
                                <h4>Em caso de dúvida, contate os administradores do sistema na sua fábrica, que são: </h4>
                            </div>
                            <div id="list">
                                {email?.map((email, index) => (
                                    <h5 key={index}>{email.email}</h5>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
